import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

//Import Components
import SectionTitle from "../../components/Shared/section-title";

// import priceBanner from "../../images/onepage/offer.png";
import priceBanner from "../../images/onepage/price-original.png";

class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            successMsg: false
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ successMsg: true });
    }
    render() {
        return (
            <React.Fragment>
                <Container>
                    <Row className="align-items-center">
                        <Col lg="12" md="12" className="mt-4 pt-2 order-1 order-md-2">
                            <SectionTitle title="Drop us a message !!!" desc=" support team will provide you one to one support to install and configure" />
                        </Col>
                    </Row>
                    <Row className="align-items-center">
                        <Col lg="6" md="6" className="mt-4 pt-2 order-1 order-md-2">
                            <div className="contact-detail mt-3">
                                <div className="icon mt-3 float-left">
                                    <i className="mdi mdi-phone text-muted mdi-36px mr-3"></i>
                                </div>
                                <div className="content mt-3 overflow-hidden d-block">
                                    <h4 className="title font-weight-bold mb-0">Phone</h4>
                                    <a href="tel:94763576648" target="_blank" rel="noopener noreferrer" className="video-play-icon h6 text-primary">Dial <span className="text-primary font-weight-bold">+94 72 785 0180</span></a>
                                </div>
                            </div>
                            <div className="contact-detail mt-3">
                                <div className="icon mt-3 float-left">
                                    <i className="mdi mdi-map-marker-outline text-muted mdi-36px mr-3"></i>
                                </div>
                                <div className="content mt-3 overflow-hidden d-block">
                                    <h4 className="title font-weight-bold mb-0">Telegram</h4>
                                    <a href="https://web.telegram.org/#/im?p=@TTC_CLIENT_SUPPORT" target="_blank" rel="noopener noreferrer" className="video-play-icon h6 text-primary">Chat <span className="text-primary font-weight-bold">@TTC_CLIENT_SUPPORT</span></a>
                                </div>
                            </div>
                            <div className="contact-detail mt-3">
                                <div className="icon mt-3 float-left">
                                    <i className="mdi mdi-email-variant text-muted mdi-36px mr-3"></i>
                                </div>
                                <div className="content mt-3 overflow-hidden d-block">
                                    <h4 className="title font-weight-bold mb-0">Email</h4>
                                    <a href="mailto:support@telegramtradecopier.com" target="_blank" rel="noopener noreferrer" className="video-play-icon h6 text-primary">Write <span className="text-primary font-weight-bold">support@telegramtradecopier.com</span></a>
                                </div>
                            </div>
                        </Col>
                        <Col lg="6" md="6" className="mt-4 pt-2 order-1 order-md-2">
                            <div className="contact-detail mt-3">
                                <div className="icon mt-3 float-left">
                                    <i className="mdi mdi-facebook text-muted mdi-36px mr-3"></i>
                                </div>
                                <div className="content mt-3 overflow-hidden d-block">
                                    <h4 className="title font-weight-bold mb-0">Facebook</h4>
                                    <a href="https://www.facebook.com/TelegramTradeCopierTeam" target="_blank" rel="noopener noreferrer" className="video-play-icon h6 text-primary">Chat <span className="text-primary font-weight-bold">@TelegramTradeCopierTeam</span></a>
                                </div>
                            </div>
                            <div className="contact-detail mt-3">
                                <div className="icon mt-3 float-left">
                                    <i className="mdi mdi-instagram text-muted mdi-36px mr-3"></i>
                                </div>
                                <div className="content mt-3 overflow-hidden d-block">
                                    <h4 className="title font-weight-bold mb-0">Instagram</h4>
                                    <a href="https://www.instagram.com/telegramtradecopier" target="_blank" rel="noopener noreferrer" className="video-play-icon h6 text-primary">Contact <span className="text-primary font-weight-bold">@TelegramTradeCopier</span></a>
                                </div>
                            </div>
                            <div className="contact-detail mt-3">
                                <div className="icon mt-3 float-left">
                                    <i className="mdi mdi-twitter text-muted mdi-36px mr-3"></i>
                                </div>
                                <div className="content mt-3 overflow-hidden d-block">
                                    <h4 className="title font-weight-bold mb-0">Twitter</h4>
                                    <a href="https://twitter.com/TgTradeCopier" target="_blank" rel="noopener noreferrer" className="video-play-icon h6 text-primary">Twitte <span className="text-primary font-weight-bold">Twitter</span></a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>

                    </Row>
                </Container>
            </React.Fragment>
        );
    }
}

export default ContactUs;